import React, { Suspense } from 'react';
import { DDD } from "../lib/ddd/ddd";
import { Helmet } from "react-helmet";
import DDDHelmet from "../components/UI/DDDHelmet";
import classes from "./AddCustomer.module.scss";
//import OrganisationMaintainer from '../components/themes/OrganisationMaintainer';
//const ThemesCreator = React.lazy(() => import('../components/themes/ThemesCreator'));
const OrganisationMaintainer = React.lazy(() => import('../components/themes/OrganisationMaintainer'));


const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const ddd = new DDD(apiRequestAddress);

const Theme = () => {
    return(<>
        <DDDHelmet title="Theme Maker"/>
        <div className={`w-100 d-flex flex-column p-5 ${classes.container}`}>
        <Suspense fallback={<div>Loading...</div>}>
            <OrganisationMaintainer/>
        </Suspense>
        </div>
    </>)
};
export default Theme;